import BaseSchema from "./base";

class Sum extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "sums";
  static fields = [
    "uuid",
    "installation",
    "parameters",
    "name",
    "createdAt",
    "updatedAt",
  ];

  static dateFields = ["createdAt", "updatedAt"];

  static relatedFields = {
    parameters: {
      m2m: true,
      owner: true,
      relatedKey: "parameters",
      tableName: "parameters",
    },
    vle: {
      reversedKey: "sum",
      tableName: "vles",
      cascade: true,
      blank: true,
    },
  };
}

export default Sum;
